module.exports = __webpack_public_path__ + "img/icon_anonyma.44fea7b2.svg";